export default "__VITE_ASSET__BbOsUwtZ__"